export default __webpack_public_path__ + "static/ringblank-a2cc4a7f75182098e7366284a1a2537d.png";